module.exports = __webpack_public_path__ + "static/media/speaking.5c077d18.svg";